import React from 'react';
import { AuthCallback } from 'casdoor-react-sdk';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '@/shared/services/storage/cookieService';
import Sdk from 'casdoor-js-sdk';
import type { SdkConfig, TokenResponse } from '../types/auth.types';

const sdkConfig: SdkConfig = {
  serverUrl: import.meta.env.VITE_ACCOUNT_SERVER_URL || 'http://localhost:3001',
  appName: import.meta.env.VITE_CASDOOR_APPNAME,
  clientId: import.meta.env.VITE_CASDOOR_CLIENTID,
  organizationName: import.meta.env.VITE_CASDOOR_ORG,
  redirectPath: import.meta.env.VITE_CASDOOR_REDIRECT,
  signinPath: import.meta.env.VITE_CASDOOR_SIGNINPATH
};

export const CasdoorSdk = new Sdk(sdkConfig);

const CasdoorCallback: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AuthCallback
      sdk={CasdoorSdk}
      serverUrl={'https://gotomztol.img-cdn-cloud.com'}
      saveTokenFromResponse={async (res: Response) => {
        const json = await res.json() as TokenResponse;
        console.log(json);
        if (json.success && json.data) {
          setCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME, json.data.access_token);
          setCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME, json.data.refresh_token);
          navigate('/');
        }
      }}
      isGetTokenSuccessful={(res: Response) => {
        // This will be checked after JSON parsing in saveTokenFromResponse
        return res.ok;
      }}
    />
  );
};

export default CasdoorCallback;

